import { CheckCircle2, FileCode2 } from "lucide-react";
import { CalloutPin, type TabCalloutProps } from "./CalloutPin";
import { SITEMAP_CALLOUTS, SITEMAPS } from "./gscData";

function SuccessPill() {
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-accent-emerald/30 bg-accent-emerald/10 px-4 py-1 text-xl font-medium text-accent-emerald">
      <CheckCircle2 className="h-5 w-5" />
      Success
    </span>
  );
}

export function SitemapsTab({ openId, visited, onOpen }: TabCalloutProps) {
  const pinProps = { openId, visited, onOpen };
  const totalUrls = SITEMAPS.reduce((sum, s) => sum + s.discovered, 0);

  return (
    <div className="flex h-full flex-col justify-center gap-6">
      <div className="flex items-center gap-3">
        <FileCode2 className="h-7 w-7 text-white/60" />
        <span className="font-display text-3xl font-semibold text-white/95">
          Submitted sitemaps
        </span>
      </div>

      <div className="relative rounded-2xl border border-white/10 bg-white/[0.03]">
        <table className="w-full">
          <thead>
            <tr className="text-xl uppercase tracking-wider text-white/50">
              <th className="px-6 py-4 text-left font-medium">Sitemap</th>
              <th className="px-6 py-4 text-right font-medium">Discovered URLs</th>
              <th className="relative px-6 py-4 text-left font-medium">
                Last read
                {/* ② Check the 'last read' date */}
                <CalloutPin
                  callout={SITEMAP_CALLOUTS.lastRead}
                  className="absolute -top-4 right-0"
                  {...pinProps}
                />
              </th>
              <th className="px-6 py-4 text-left font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {SITEMAPS.map((s) => (
              <tr
                key={s.file}
                className="border-t border-white/[0.06] transition-colors hover:bg-white/5"
              >
                <td className="px-6 py-5 font-mono text-xl text-white/90">{s.file}</td>
                <td className="px-6 py-5 text-right text-xl tabular-nums text-white/85">
                  {s.discovered.toLocaleString("en-US")}
                </td>
                <td className="px-6 py-5 text-xl text-white/70">{s.lastRead}</td>
                <td className="px-6 py-5">
                  <SuccessPill />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="border-t border-white/[0.06] px-6 py-3.5 text-xl text-white/55">
          {SITEMAPS.length} sitemaps · {totalUrls.toLocaleString("en-US")} URLs discovered
        </div>

        {/* ① A sitemap is the menu you hand Google */}
        <CalloutPin
          callout={SITEMAP_CALLOUTS.menu}
          className="absolute -left-4 -top-4"
          {...pinProps}
        />
      </div>
    </div>
  );
}
